import { render, staticRenderFns } from "./AthleteSelfAssessmentStatCard.vue?vue&type=template&id=1aba72d0&scoped=true&"
import script from "./AthleteSelfAssessmentStatCard.vue?vue&type=script&lang=ts&"
export * from "./AthleteSelfAssessmentStatCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aba72d0",
  null
  
)

export default component.exports